/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
export type ImageVersionTypeName = "large" | "master" | "medium" | "original" | "placeholder" | "small" | "thumb" | "zoom" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedLayout_viewer$ref: FragmentReference;
export type PdpSharedLayout_viewer = {|
  +isPdpUrlTranslationEnabled: ?boolean,
  +item: ?{|
    +isMultiSku: boolean,
    +pdpTrackingVpvParams?: ?any,
    +saveSearchData: ?{|
      +page: ?string
    |},
    +microdata?: ?string,
    +pdpURL?: ?string,
    +localizedPdpUrl?: ?string,
    +pdpMeta?: ?{|
      +title: ?string,
      +description: ?string,
      +ogTitle: ?string,
      +productPriceAmount: ?string,
      +productPriceCurrency: ?string,
    |},
    +photos?: ?$ReadOnlyArray<?{|
      +versions: ?$ReadOnlyArray<?{|
        +webPath: ?string,
        +type: ?{|
          +name: ?ImageVersionTypeName
        |},
      |}>
    |}>,
    +isListingNotListed?: ?boolean,
    +isMissingTranslatedItemTitle?: ?boolean,
    +seller?: ?{|
      +isInternal: ?boolean,
      +serviceId: ?string,
    |},
    +isSold?: ?boolean,
    +metrics?: ?$ReadOnlyArray<?{|
      +value: ?string
    |}>,
    +attributes?: ?{|
      +period: ?$ReadOnlyArray<?{|
        +option: ?{|
          +name: ?string
        |}
      |}>
    |},
    +browseUrl?: ?string,
    +categoryCode?: ?string,
    +viewInRoomPhotos?: ?$ReadOnlyArray<?{|
      +src: ?string
    |}>,
    +contemporaryTrackingString?: string,
    +skus: ?$ReadOnlyArray<?{|
      +skuId: ?string,
      +images: ?$ReadOnlyArray<?{|
        +id: string
      |}>,
    |}>,
  |},
  +$refType: PdpSharedLayout_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Fragment",
  "name": "PdpSharedLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "itemId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    },
    {
      "kind": "RootArgument",
      "name": "isClient",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "fetchPdp",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "forcedCurrency",
      "type": "Currency"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isPdpUrlTranslationEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "translatedPdpUrls",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "item",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "itemId",
          "type": "String!"
        }
      ],
      "concreteType": "Item",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isMultiSku",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "saveSearchData",
          "storageKey": null,
          "args": null,
          "concreteType": "SaveSearchDataType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "page",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "skus",
          "storageKey": null,
          "args": null,
          "concreteType": "ItemSkuType",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "skuId",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "images",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemPhoto",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "id",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "fetchPdp",
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "seller",
              "storageKey": null,
              "args": null,
              "concreteType": "Seller",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "isInternal",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "microdata",
              "args": [
                {
                  "kind": "Variable",
                  "name": "currency",
                  "variableName": "forcedCurrency",
                  "type": "Currency"
                }
              ],
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "localizedPdpUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "pdpMeta",
              "storageKey": null,
              "args": null,
              "concreteType": "pdpMetaItems",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "title",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "description",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "ogTitle",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "productPriceAmount",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "productPriceCurrency",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "photos",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemPhoto",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "versions",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "ItemPhotoVersion",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "webPath",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "type",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "ImageVersionType",
                      "plural": false,
                      "selections": (v0/*: any*/)
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isListingNotListed",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isMissingTranslatedItemTitle",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pdpURL",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "isSold",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "metrics",
              "storageKey": "metrics(metricTypes:[\"LISTING_VIEWS\"],timeRange:\"LAST_6_MONTHS\")",
              "args": [
                {
                  "kind": "Literal",
                  "name": "metricTypes",
                  "value": [
                    "LISTING_VIEWS"
                  ],
                  "type": "[MetricType]!"
                },
                {
                  "kind": "Literal",
                  "name": "timeRange",
                  "value": "LAST_6_MONTHS",
                  "type": "MetricsTimeRangeEnum!"
                }
              ],
              "concreteType": "MetricDetailType",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "attributes",
              "storageKey": null,
              "args": null,
              "concreteType": "ItemAttributes",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "period",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "AttributeValue",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "option",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "AttributeOption",
                      "plural": false,
                      "selections": (v0/*: any*/)
                    }
                  ]
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "browseUrl",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "categoryCode",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "viewInRoomPhotos",
              "storageKey": null,
              "args": null,
              "concreteType": "viewInRoomPhotos",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "src",
                  "args": null,
                  "storageKey": null
                }
              ]
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "contemporaryTrackingString",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "Condition",
          "passingValue": true,
          "condition": "isClient",
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pdpTrackingVpvParams",
              "args": [
                {
                  "kind": "Variable",
                  "name": "userId",
                  "variableName": "userId",
                  "type": "String"
                }
              ],
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e0f073d71b7a1b8f46c459ca7ffe2515';
module.exports = node;
